import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionOidcService } from 'app/services/external/auth-oidc/session-oidc.service';
import { internalRoutes } from 'environments/common/internal-routes';

export const guestGuard: CanActivateFn = () => {
  const sessionOidcService = inject(SessionOidcService);
  const router = inject(Router);
  return sessionOidcService.currentSessionOidc().isAuthenticated ? router.createUrlTree([internalRoutes.Home]) : true;
};
